import * as React from 'react'
import { Form } from 'react-bootstrap'
import Annotation from 'components/Annotation'
import { KeyValue } from 'utilities/resources/options'

interface Props {
  name: string
  value?: string
  label: string
  items: KeyValue[]
  bold?: boolean
  className?: string
  style?: React.CSSProperties
  setValue?: (value: string) => void
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void
  notes?: string[]
  errors?: string[]
}

const Component: React.FC<Props> = ({ name, value, label, items, bold, className, style, setValue, onChange, notes, errors }) => {
  const originalOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (setValue) {
      setValue(event.target.value)
    }
    if (onChange) {
      onChange(event)
    }
  }
  const noteList = (notes ?? []).filter(Boolean)
  const errorList = (errors ?? []).filter(Boolean)
  return (
    <div id={`input_item_id_${name}`} className={className} style={style}>
      <label className={`${bold ? 'fw-bold ' : ''}font-15`}>{label}</label>
      <div>
        <Form.Select name={name} className={`select${errorList.length > 0 ? ' border-danger border-2' : ''}`} value={value} onChange={originalOnChange}>
          {items.map(({ key, value }, index) => (
            <option key={index} value={key}>
              {value}
            </option>
          ))}
        </Form.Select>
      </div>
      {noteList.length > 0 && <Annotation notes={noteList} />}
      {errorList.length > 0 && <Annotation notes={errorList} warn />}
    </div>
  )
}

export default Component
